<template>
  <b-container  class="d-flex justify-content-center align-items-center h-100">
    <div>
      <h3 class="caption">Login</h3>
      <b-form @submit.prevent="obtain">
        <b-form-group v-if="serverError" class="server-error text-center">{{ serverError }}</b-form-group>
        <b-form-group>
          <input
            class="form-control form-control-lg"
            id="username"
            required
            v-model="username"
            type="text"
            placeholder="username">
        </b-form-group>
        <b-form-group>
          <b-input-group>
            <template v-if="passwordVisible">
              <b-input
                class="form-control form-control-lg"
                id="password"
                required
                v-model="password"
                type="text"
                placeholder="password"/>
              <span title="Hide password" v-on:click="togglePasswordVisibility">
                <fa-icon id="eye" icon="eye-slash"/>
              </span>
            </template>
            <template v-else>
              <b-input
                class="form-control form-control-lg"
                id="password"
                required
                v-model="password"
                type="password"
                placeholder="password"
                autocomplete="on"/>
              <span title="Show password" v-on:click="togglePasswordVisibility">
                <fa-icon id="eye" icon="eye"/>
              </span>
            </template>
          </b-input-group>
        </b-form-group>
        <b-form-group>
          <b-button class="btn btn-info btn-lg btn-block" type="submit">Login</b-button>
          <a href="/signup" class="float-left">Register</a>
          <!-- <a href="" class="float-right">Forgot password</a> -->
        </b-form-group>
      </b-form>
    </div>
  </b-container>
</template>

<script>

export default {
  name: 'Login',

  data () {
    return { username: '', password: '', token: '', passwordVisible: false, serverError: '' }
  },

  mounted () {
    this.username = sessionStorage.getItem('user')
  },

  methods: {

    togglePasswordVisibility (evt) {
      this.passwordVisible = !this.passwordVisible
    },

    verify (evt) {
      // verify JWT token
      this.$http.post('/api/v1/token/verify/', { token: this.token })
        .then(response => {
          console.debug('verify token succeeded: ' + response.statusText)
        })
        .catch(err => {
          // error code 400 (Bad Request). Reason should be in response.statusText
          console.debug('verify token failed: ' + JSON.stringify(err.response.data))
        })
    },

    refresh (evt) {
      // refresh JWT token
      this.$http.post('/api/v1/token/refresh/', { token: this.token })
        .then(response => {
          const token = response.data.token
          sessionStorage.setItem('token', token)
          sessionStorage.setItem('user', this.username)
          console.debug('refresh token succeeded: ' + response.statusText)
        })
        .catch(err => {
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('user')
          console.debug('refresh token failed: ' + JSON.stringify(err.response.data))
        })
    },

    obtain (evt) {
      // obtain JWT token
      this.$http.post('/api/v1/token/', { username: this.username, password: this.password })
        .then(response => {
          this.token = response.data.token
          sessionStorage.setItem('token', this.token)
          sessionStorage.setItem('user', this.username)
          // console.debug("login succeeded: " + response.statusText);
          // console.debug("query: " + JSON.stringify(this.$route.query));
          let nextUrl = this.$route.query.next
          if (nextUrl != null) {
            this.$router.push(nextUrl)
          } else {
            this.$router.push({ name: 'home' })
          }
        })
        .catch(err => {
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('user')
          console.debug('login failed: ' + JSON.stringify(err.response.data))
          this.serverError = err.response.data.non_field_errors[0]
        })
    }
  }
}
</script>

<style>
#eye {
  position: absolute;
  right: 8px;
  top: 12px;
  z-index: 999;
}
.server-error {
  font-size: 16px;
  font-weight: 400;
  color: red;
  width: 100%;
}
  .form-control {
    min-width: 400px;
  }
</style>
